
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recentUserOps",
      function () {
        return require("private-next-pages/recentUserOps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recentUserOps"])
      });
    }
  